import { useRoute, useRouter } from "vue-router";

export function useForward() {
    const route = useRoute();
    const router = useRouter();

    const checkQuery = (page, cb) => {
        if (route.query.page && route.query.page == page) {
            cb();
        }      
    }

    const forward = (page) => {
        router.push({ query: { page }});
    }

    return { checkQuery, forward };
}